"use strict";

jQuery(($) => {
	$('.sponsors-slider .sponsors').flickity({
		cellAlign: "left",
		wrapAround: true,
		pageDots: false,
		autoPlay: 4500
	});

	//Close Button for Donate Menu
	$(document).ready(function(){
		$('.touch-hoverfix .menu > .menu-item-has-children > .sub-menu').append('<li class="menu-item close"><a href="#" class="close">Close</a></li>');
		$('.touch-hoverfix .menu > .menu-item > .sub-menu > .menu-item.close').click(function(e){
			$(this).parent('.sub-menu').toggleClass('show-sub-menu');
		});
		$('.touch-hoverfix .menu-item-has-children').click(function(e){
			if($(this).hasClass('show-sub-menu')){
				$(this).removeClass('show-sub-menu');
			}else{
				e.preventDefault();
				$(this).addClass('show-sub-menu');
			}
		});

		$('.people a.show-bio').click(function(e){
			e.preventDefault();
			$(this).parents('.people').find('.bio').toggleClass('show');
		});

		$('.bio').click(function(e){
			$(this).toggleClass('show');
		});
		$('.close').click(function(e){
			e.preventDefault();
			$(this).toggleClass('show');
		});

		if($('.back-to-top').length){
			$('.back-to-top').click(function(e){
				e.preventDefault();
				$("body,html").animate({"scrollTop": "0px"}, 800);
			});
		}

	})

});